import { useSettings } from '@capsicum/common';

import { usePoblanoTutorialEligibility } from './usePoblanoTutorialEligibility';

const TUTORIAL_NAME = 'fanZone-tokenHuntEntryPoint-tutorial';

type UseTokenHuntEntryTutorialProps = {
	enabled: boolean;
};

export const useTokenHuntEntryTutorial = ({ enabled }: UseTokenHuntEntryTutorialProps = { enabled: true }) => {
	const {
		areSettingsLoading,
		settings: { isTokenHuntEnabled }
	} = useSettings();

	const {
		isEnabled,
		isExistingUser,
		isLoading: isPoblanoTutorialLoading
	} = usePoblanoTutorialEligibility({
		enabled: enabled && isTokenHuntEnabled
	});

	return {
		isEnabled: isEnabled && isExistingUser,
		isExistingUser,
		isLoading: areSettingsLoading || isPoblanoTutorialLoading,
		name: TUTORIAL_NAME
	};
};
